import cx from "classnames";

import type { InputType } from "../Input/TextInput";

import styles from "./TextArea.scss";

interface TextareaProps {
  input: InputType;
  label?: string;
  placeholder?: string;
  rows?: number;
  isDisabled?: boolean;
  maxLength?: number;
  minLength?: number;
  className?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

const Textarea = ({
  label = "",
  placeholder = "",
  input,
  rows = 3,
  isDisabled = false,
  maxLength,
  minLength,
  className = "",
  onKeyDown
}: TextareaProps) => (
  <textarea
    {...input}
    onKeyDown={onKeyDown}
    aria-label={label}
    className={cx({ [styles.disabled]: isDisabled }, styles.textarea, className)}
    data-testid={`textArea:${input.name}`}
    data-name={input.name}
    placeholder={placeholder}
    rows={rows}
    disabled={isDisabled}
    minLength={minLength}
    maxLength={maxLength}
  />
);

export default Textarea;
